import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsDeleteRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-delete',
	path: '(/secure/|/)project/DeleteProject([!%]?[\\w]*).jspa',
	query: ['pid'],
};
